module.exports = __webpack_public_path__ + "static/spicewave-97e62fbcbbb16c52310eec61ec83f206.jpg";